<template>
        <div class="email-template">
            <h1 class="text-left">Email Header & Signature</h1>

            <ValidationObserver ref="emailTemplateForm" tag="form" v-on:submit.prevent="saveContent()">
                <div class="email-editor">

                    <div class="email-editor-wrapper" ref="editor">
                      <h5 class="mt-3">Header <span class="text-note">(prepended at the beginning of all emails)</span></h5>
                      <div class="email-content-wrapper">
                          <div ref="editorHeader" class="email-content"></div>
                      </div>

                      <h5 class="mt-3">Signature <span class="text-note">(appended at the end of all emails)</span></h5>
                      <div class="email-content-wrapper">
                          <div ref="editorSignature" class="email-content"></div>
                      </div>
                    </div>

                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : updating, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>

                    <div class="row" v-show="!updating">
                        <div class="col-6 offset-3">
                            <div class="row email-editor-buttons">
                                <div class="col-6">
                                    <button class="btn btn-secondary" v-on:click.prevent="cancel">Cancel</button>
                                </div>
                                <div class="col-6">
                                    <button class="btn btn-primary" v-bind:aria-disabled="!changed" v-bind:class="{'btn-disabled' : !changed}">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationObserver>

            <confirm-dialog v-bind:continuePrimaryText="'Save'"
                            v-bind:message="confirmLoseChangesMessage"
                            v-bind:callbackPrimaryName="'save-email-template'"
                            v-bind:callbackPrimaryReference="'save'"
                            v-if="showConfirmLoseChangesDialog"/>

        </div>
</template>

<script>
    import jQuery from "jquery";
    import "bootstrap"
    import "summernote/dist/summernote-bs4.js"
    /* Moved the CSS file to main.js, so that the fonts load properly. Else problem, loading twice? */
    import "summernote-cleaner/summernote-cleaner.js"
    import { ValidationObserver } from 'vee-validate'

    import { store, getters } from '../store.js'
    import ConfirmDialog from '../components/ConfirmDialog.vue'

    import { variablesMixin } from '../mixins/VariablesMixin'
    import { emailEditorMixin } from '../mixins/EmailEditorMixin.js'

    export default {
        name: 'EditEmailHeaderSignature',
        components: {
            ValidationObserver, ConfirmDialog
        },
        mixins: [ variablesMixin, emailEditorMixin ],
        data() {
            return {
                reference: null,
                subjectInput: null,
                emailHeader: "",
                emailSignature: "",
                attachments: [],
                requiredVariables: [],
                changed: false,
                cancelling: false,
                updating: false,
                error: false,
                infoMessage: "",
                confirmLoseChangesMessage: "You have un-saved changes to your email header and/or signature. Would you like to save your work before leaving the page?",
                showConfirmLoseChangesDialog: false,
                showFileSelectorDialog: false,
                navigatingToRoute: ""
            }
        },
        computed: {
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            }
        },
        methods: {
            cancel: function() {
                console.log("cancel");
                this.cancelling = true;
                this.$router.push({name: 'ListEstablishments'});
            },
            saveContent: async function() {
                console.log("saving");
                const contentHeader = this.editorHeaderElement.summernote('code');
                const contentSignature = this.editorSignatureElement.summernote('code');
                console.log(contentHeader);
                console.log(contentSignature);
                console.log(store.currentEstablishmentReference);
                try {
                    const success = await this.$refs.emailTemplateForm.validate();
                    console.log("Validated:" + success);
                    if (!success) {
                        return;
                    }
                    this.updating = true;
                    this.error = false;
                    this.infoMessage = "Saving email header & signature";

                    const body = {
                        emailHeader: "" + contentHeader,
                        emailSignature: "" + contentSignature,
                    };

                    const response = await this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/email-config/header-signature', body);
                    console.log("Email header and signature updated. Response: " + response);
                    this.infoMessage = "Email header & signature saved";
                    this.changed = false;
                    setTimeout(() => {
                        this.updating = false;
                    }, 2000);
                } catch (error) {
                    this.updating = false;
                    this.error = true;
                    if (error.response) {
                        this.infoMessage = error.response.data.message;
                    } else {
                        this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again";
                    }
                }
            },
            personalisationButton: function (context) {
                var ui = jQuery.summernote.ui;

                var list = "";
                for (let variable of this.generalVariables) {
                    list = list + "<li>" + variable.name + "</li>";
                }
                list = list + "<li class='email-editor-toolbar-dropdown__separator text-capitalize'>" + this.getUnitTypeForDisplay + " variables</li>";
                for (let roomTypeVariable of this.roomTypeVariables) {
                    list = list + "<li>" + roomTypeVariable.name + "</li>";
                }

                // create button
                var button = ui.buttonGroup([
                    ui.button({
                        className: 'dropdown-toggle email-editor-toolbar-button-custom',
                        contents: '<strong>${...}</strong>',
                        tooltip: 'Personalisation variable',
                        data: {
                            toggle: 'dropdown'
                        }
                    }),
                    ui.dropdown({
                        className: 'email-editor-toolbar-dropdown',
                        contents: "<ul style=\"max-height: 50vh; overflow-y: scroll;\">" + list + "</ul>",
                        callback: function ($dropdown) {
                            console.log($dropdown);
                            $dropdown.find('li').each(function () {
                                jQuery(this).click(function (e) {
                                    context.invoke('editor.restoreRange');
                                    context.invoke('editor.focus');
                                    context.invoke("editor.insertText", "${" + jQuery(this).html() + "}");
                                    e.preventDefault();
                                });
                            });
                        }
                    })
                ]);

                return button.render();   // return button as jquery object
            }
        },
        mounted: async function() {
            await this.fetchVariables();
            this.sortVariables();

            this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/email-config/header-signature').then(response => {
                this.emailHeader = response.data.emailHeader;
                this.emailSignature = response.data.emailSignature;
                this.editorHeaderElement.summernote('code', this.emailHeader);
                this.editorSignatureElement.summernote('code', this.emailSignature);
                this.changed = false;
            }).catch(error => {
                console.log(error)
            });

            const totalHeight = this.$refs.editor.clientHeight;
            const editorHeight = (totalHeight  - 245) / 2;
            console.log(totalHeight);
            console.log(editorHeight);

            (function ($, _this) {
                //Check for the text editor
                if ($.fn.summernote) {
                    let insertButtons = ['link', 'picture', 'personalisation', 'ctaStyling'];

                    _this.editorHeaderElement = $(_this.$refs.editorHeader);  // I like to use refs instead of $(selector)
                    _this.editorHeaderElement.summernote({
                        lang: 'en-US',
                        placeholder: 'enter content here...',
                        height: editorHeight,
                        minHeight: null,
                        maxHeight: null,
                        focus: true,
                        toolbar: [
                            ['cleaner',['cleaner']], // The Button
                            ['class', ['style']],
                            ['style', ['bold', 'underline', 'clear']],
                            ['font', ['fontname', 'fontsize']],
                            ['color', ['color']],
                            ['para', ['ul', 'ol', 'paragraph', 'height']],
                            ['table', ['table']],
                            ['insert', insertButtons],
                            ['view', ['codeview']],
                            // ['view', ['codeview', 'help']],
                            ['misc', ['undo', 'redo']],
                        ],
                        fontSizes: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '24', '36'],
                        buttons: {
                            personalisation: _this.personalisationButton
                        },
                        callbacks: {
                            onChange: function(content) {
                                _this.changed = true;
                                _this.checkEmailSize(content);
                            },
                            // Intercept image uploads (insert → resize → insert)
                            onImageUpload: function(files) {
                                for (let file of files) {
                                    if (!file.type.startsWith("image/")) continue;

                                    _this.resizeImage(file, 600, function(resizedBlob) {
                                        // Add resized image to SummerNote
                                        const reader = new FileReader();
                                        reader.onload = e => {
                                            _this.editorHeaderElement.summernote("insertImage", e.target.result);
                                        };
                                        reader.readAsDataURL(resizedBlob);
                                    });
                                }
                            },
                            // Intercept Pasting HTML content that already has <img src="data:image/...">
                            onPaste: function(e) {
                                const clipboard = (e.originalEvent || e).clipboardData;
                                if (!clipboard) return;

                                const html = clipboard.getData('text/html');
                                if (html && html.includes('data:image/')) {
                                    // Prevent Summernote from inserting it
                                    e.preventDefault();
                                    e.stopPropagation();

                                    // Extract base64 images and resize them manually
                                    _this.handlePastedHtmlImages(html, 600, '#summernote');
                                }
                            }
                        },
                        cleaner: {
                            action: 'both', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
                            icon: ' <i class="fas fa-broom"></i>',
                            keepHtml: true,
                            keepTagContents: ['span'], //Remove tags and keep the contents
                            badTags: ['applet', 'col', 'colgroup', 'embed', 'noframes', 'noscript', 'script', 'style', 'title', 'meta', 'link', 'head'], //Remove full tags with contents
                            badAttributes: ['bgcolor', 'border', 'height', 'cellpadding', 'cellspacing', 'lang', 'start', 'style', 'class', 'valign', 'width', 'data-(.*?)'], //Remove attributes from remaining tags
                            limitChars: 0, // 0|# 0 disables option
                            limitDisplay: 'both', // none|text|html|both
                            limitStop: false, // true/false
                            notTimeOut: 850, //time before status message is hidden in miliseconds
                            keepImages: true,
                            imagePlaceholder: 'https://via.placeholder.com/200'
                        }
                    });

                    _this.editorSignatureElement = $(_this.$refs.editorSignature);  // I like to use refs instead of $(selector)
                    _this.editorSignatureElement.summernote({
                        lang: 'en-US',
                        placeholder: 'enter content here...',
                        height: editorHeight,
                        minHeight: null,
                        maxHeight: null,
                        focus: true,
                        toolbar: [
                            ['cleaner',['cleaner']], // The Button
                            ['class', ['style']],
                            ['style', ['bold', 'underline', 'clear']],
                            ['font', ['fontname', 'fontsize']],
                            ['color', ['color']],
                            ['para', ['ul', 'ol', 'paragraph', 'height']],
                            ['table', ['table']],
                            ['insert', insertButtons],
                            ['view', ['codeview']],
                            // ['view', ['codeview', 'help']],
                            ['misc', ['undo', 'redo']],
                        ],
                        fontSizes: ['8', '9', '10', '11', '12', '14', '16', '18', '20', '24', '36'],
                        buttons: {
                            personalisation: _this.personalisationButton,
                            ctaStyling: _this.styleCTAButton
                        },
                        callbacks: {
                            onChange: function(content) {
                                _this.changed = true;
                                _this.checkEmailSize(content);
                            },
                            // Intercept image uploads (insert → resize → insert)
                            onImageUpload: function(files) {
                                for (let file of files) {
                                    if (!file.type.startsWith("image/")) continue;

                                    _this.resizeImage(file, 600, function(resizedBlob) {
                                        // Add resized image to SummerNote
                                        const reader = new FileReader();
                                        reader.onload = e => {
                                            _this.editorSignatureElement.summernote("insertImage", e.target.result);
                                        };
                                        reader.readAsDataURL(resizedBlob);
                                    });
                                }
                            },
                            // Intercept Pasting HTML content that already has <img src="data:image/...">
                            onPaste: function(e) {
                                const clipboard = (e.originalEvent || e).clipboardData;
                                if (!clipboard) return;

                                const html = clipboard.getData('text/html');
                                if (html && html.includes('data:image/')) {
                                    // Prevent Summernote from inserting it
                                    e.preventDefault();
                                    e.stopPropagation();

                                    // Extract base64 images and resize them manually
                                    _this.handlePastedHtmlImages(html, 600, '#summernote');
                                }
                            }
                        },
                        cleaner: {
                            action: 'both', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
                            icon: ' <i class="fas fa-broom"></i>',
                            keepHtml: true,
                            keepTagContents: ['span'], //Remove tags and keep the contents
                            badTags: ['applet', 'col', 'colgroup', 'embed', 'noframes', 'noscript', 'script', 'style', 'title', 'meta', 'link', 'head'], //Remove full tags with contents
                            badAttributes: ['bgcolor', 'border', 'height', 'cellpadding', 'cellspacing', 'lang', 'start', 'style', 'class', 'valign', 'width', 'data-(.*?)'], //Remove attributes from remaining tags
                            limitChars: 0, // 0|# 0 disables option
                            limitDisplay: 'both', // none|text|html|both
                            limitStop: false, // true/false
                            notTimeOut: 850, //time before status message is hidden in miliseconds
                            keepImages: true,
                            imagePlaceholder: 'https://via.placeholder.com/200'
                        }
                    });
                } else {
                    //TODO: load error message in UI
                    alert('The text editor is not loaded properly for the content.  Please contact an administrator.');
                }

            })(jQuery, this); // init jquery

            this.saveBeforeLeavingFn = async (action) => {
                if (action === "save") {
                    await this.saveContent();
                    this.$router.push({name: this.navigatingToRoute.name });
                    this.showConfirmLoseChangesDialog = false;
                } else {
                    this.showConfirmLoseChangesDialog = false;
                }
            };
            this.$root.$on('save-email-template', this.saveBeforeLeavingFn);

            this.$root.$on('finished-selecting-files', this.attachFiles);
        },
        beforeDestroy () {
            this.requiredVariables.splice(0, this.requiredVariables.length);
            jQuery('#summernote').summernote('destroy');

            this.$root.$off('save-email-template', this.saveBeforeLeavingFn);
            this.$root.$off('finished-selecting-files', this.attachFiles);
        },
        beforeRouteLeave (to, from, next) {
            if (this.changed && !this.cancelling) {
                this.navigatingToRoute = to;
                this.showConfirmLoseChangesDialog = true;
            } else {
                next();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/layout/forms.scss";
    @import "../styles/components/question_answer";
    @import "../styles/components/edit_email";
</style>

<style lang="scss">
    .email-editor-toolbar-dropdown {
        ul {
            list-style: none;
            margin: 0;
            padding: 0;
            /*padding: 0 10px 0 20px;*/
        }

        li {
            padding: 3px 10px 3px 20px;
        }

        li:hover {
            cursor: pointer;
            background-color: $grey-light;
        }
    }

    .email-editor-toolbar-dropdown__separator:hover {
        cursor: inherit !important;
        background-color: inherit !important;
    }

    .email-editor-toolbar-dropdown__separator {
        padding: 15px 10px 3px 20px !important;
        color: $grey-medium;
        font-style: italic;
    }

    .list-enter-active,
    .list-leave-active {
        transition: all 0.5s ease;
    }
    .list-enter-from,
    .list-leave-to {
        opacity: 0;
        transform: translateX(100px);
    }



</style>
